import React, { useState, useEffect } from 'react';

// Toast
import { toast } from 'react-toastify';

// Axios
import axios from 'axios';

// MUI Components
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

const EditableEmail = ({ site }) => {

    const [ email, setEmail ]       = useState(site.admin_email || '');
    const [ value, setValue ]       = useState(site.admin_email || '');
    const [ editing, setEditing ]   = useState(false);
    const [ saving, setSaving ]     = useState(false);

    // Keeps the cell in sync when the email is changed elsewhere and the table refreshes.
    useEffect(() => {
        setEmail(site.admin_email || '');
        setValue(site.admin_email || '');
    }, [site.admin_email]);

    const updateAdminEmail = () => {
        if( saving ){
            return;
        }
        setSaving(true);
        axios.post(`/site/${site.id}/update-admin-email`, {
            admin_email: value
        }).then(response => {
            if( response.data.success ){
                toast.success(response.data.message);
                setEmail(value);
                setEditing(false);
            }
            else{
                toast.error(response.data.message);
            }
        }).catch(() => {
            toast.error('Failed to update admin email');
        }).finally(() => {
            setSaving(false);
        });
    }

    const cancelEdit = () => {
        setValue(email);
        setEditing(false);
    }

    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {(editing) ? (
                <>
                    <TextField
                        type='email'
                        size='small'
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                        autoFocus
                    />
                    <IconButton size='small' onClick={updateAdminEmail} disabled={saving}>
                        <CheckIcon fontSize='small' />
                    </IconButton>
                    <IconButton size='small' onClick={cancelEdit} disabled={saving}>
                        <CloseIcon fontSize='small' />
                    </IconButton>
                </>
            ) : (
                <>
                    {email}
                    <IconButton size='small' onClick={() => setEditing(true)}>
                        <EditIcon fontSize='small' />
                    </IconButton>
                </>
            )}
        </Box>
    );

}

export default EditableEmail;
